//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { TrackingIdPrefix } from '@models/TrackingId';

export const UIA_BULK_ACTIONS_TRACKING_ID_PREFIX: TrackingIdPrefix =
  'uia-bulk-actions-';

export const UiaBulkActionsTrackingIds = {
  CANCEL_DELETE_FROM_LIBRARY: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}cancel-delete-from-library`,
  DELETE_FROM_LIBRARY_CONFIRMATION: `${UIA_BULK_ACTIONS_TRACKING_ID_PREFIX}delete-from-library-confirmation`,
};
